import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../../app.state';

import { UnitsActions } from './units.actions';
import { UnitsSelectors } from './units.selectors';
import { SettingsPreference, SettingsPreferenceOption } from './units.state';

@Injectable({ providedIn: 'root' })
export class UnitsStore {
  loading$ = this.store.select(UnitsSelectors.isLoading());

  settingsPreferences$ = this.store.select(UnitsSelectors.settingsPreferences());
  isTemperatureMetric$ = this.store.select(UnitsSelectors.isTemperatureMetricUnit());
  isVolumeMetricUnit$ = this.store.select(UnitsSelectors.isVolumeMetricUnit());
  isPressureMetricUnit$ = this.store.select(UnitsSelectors.isPressureMetricUnit());
  isFlowRateMetricUnit$ = this.store.select(UnitsSelectors.isFlowRateMetricUnit());

  constructor(private store: Store<AppState>) {}

  fetchTemperatureUnit(): void {
    this.store.dispatch(UnitsActions.getSettingsPreferences());
  }

  setSettingsPreference(value: SettingsPreferenceOption, preference: SettingsPreference): void {
    this.store.dispatch(UnitsActions.setSettingsPreferences({ value, preference }));
  }
}
